<template>
	<section class="generated--wrap" v-show="generatedCode" id="generated">
		<div class="generated wrapper flex align-center direction-column">

			<h3 class="generated__title" v-html="$t('generated.title')"></h3>

			<div class="generated__preview"
				 ref="preview"
				 :style="previewStyle"
			>
				<div ref="copySignatureText" v-html="generatedCode"></div>
				<copy-btn
					:tooltipClass="'left__sm'"
					@clickCopy="copySignatureText"
					:visibleCopied="copiedStatus.text"
					@mouseleave="hideTooltip('text')"
				></copy-btn>
			</div>

			<p class="generated__code--title" v-html="$t('generated.codeTitle')"></p>
			<div class="generated__code--wrap">
				<copy-btn
					:tooltipClass="'left'"
					@clickCopy="copyToClipboard"
					:visibleCopied="copiedStatus.code"
					@mouseleave="hideTooltip('code')"
				></copy-btn>
				<div
					class="generated__code"
					ref="scrollAreaWrap"
					@scroll="initScrollBar()"
				>
					<div class="custom__scrollbar--wrap"
						 ref="scrollBarWrap"
					>
						<div class="custom__scrollbar"
							 :style="{top: scrollBar.top + 'px', height: scrollBar.height + 'px'}"
							 ref="verticalScroll"
							 @mousedown.prevent="behaviorVerticalScroll"
						></div>
					</div>

					<prism-editor
						:code="generatedCode"
						:language="'html'"
						:readonly="true"
					></prism-editor>

					<div class="horizontalScrollBar--wrap"
						 ref="horizontalScrollBarWrap"
					>
						<div class="horizontalScrollBar"
							 ref="horizontalScroll"
							 :style="{left: scrollBar.left + 'px', width: scrollBar.width + 'px'}"
							 @mousedown.prevent="behaviorHorizontalScroll"
						></div>
					</div>
				</div>

				<input type="text" ref="copyInput" :value="generatedCode" v-if="visibleCopyInput">
			</div>

		</div>
	</section>
</template>

<script>

	import PrismEditor from 'vue-prism-editor'
	import {customVerticalScrollBar, horizontalCustomScrollBar} from "@/plugin/customScrollBar";
	import {zoomPreviewMixin} from "@/plugin/zoomPreview";

	export default {

		data() {
			return {
				visibleCopyInput: false,
				copiedStatus: {
					text: false,
					code: false
				}
			}
		},
		computed: {
			generatedCode() {
				return this.$store.state.generatedCode;
			}
		},
		methods: {
			hideTooltip(e) {
				this.copiedStatus[e] = false;
			},
			copySignatureText() {
				const target = this.$refs.copySignatureText.querySelector('div');
				const range = document.createRange();
				const selection = window.getSelection();

				range.selectNode(target);
				selection.removeAllRanges();
				selection.addRange(range);
				document.execCommand("copy");
				window.getSelection().removeAllRanges();
				this.copiedStatus.text = true;
			},
			copyToClipboard() {
				this.visibleCopyInput = true;
				this.$nextTick(() => {
					const copyInput = this.$refs.copyInput;
					copyInput.select();
					try {
						const successful = document.execCommand('copy');
						const msg = successful ? 'successful' : 'unsuccessful';
						console.log(msg);
					} catch (err) {
						console.log('Oops, unable to copy');
					}
					this.visibleCopyInput = false;
					this.copiedStatus.code = true;
				})
			},
			initScrollBar() {
				this.initVerticalScrollBar();
				this.initHorizontalScrollBar()
			}
		},
		watch: {
			generatedCode() {
				this.$nextTick(() => {
					this.initScrollBar();
					this.zoomPreview(false);
				})
			}
		},
		components: {
			PrismEditor,
			copyBtn: () => import('Components/subComponents/copyBtnWidthTooltip')
		},
		mixins: [customVerticalScrollBar, horizontalCustomScrollBar, zoomPreviewMixin],
	}

</script>